import React, { Component } from "react";
import InstaComponent from "../components/general/music/instaComponent.jsx";

class Instapiano extends Component {
  state = {};
  render() {
    return (
      <React.Fragment>
        <InstaComponent />
      </React.Fragment>
    );
  }
}

export default Instapiano;
